import { APP_ENV_STATE_ID } from 'src/core/config';
import { readJson } from 'src/core/engine/utils/readJson';

declare let __webpack_public_path__: string;

/**
 * Load webpack assets from the environment's CDN, if it has one.
 *
 * This must stay the first import of the browser entry, so it runs
 * before any other module builds an asset URL.
 */
const cdnUrl = readJson(APP_ENV_STATE_ID).CDN_URL;

if (cdnUrl) {
    __webpack_public_path__ = cdnUrl + __webpack_public_path__;
}
